import React from 'react';
import { Phone, Mail, MessageSquare } from 'lucide-react';

const ClientInformation = ({ client, onMessageClient, unreadChatCount = 0 }) => {
  if (!client) return null;

  const unread = typeof unreadChatCount === 'number' && unreadChatCount > 0 ? unreadChatCount : 0;

  return (
    <section className="rounded-lg border border-gray-200 bg-surface p-5 sm:p-6 shadow-sm">
      <div className="mb-4">
        <h2 className="text-base font-bold text-gray-900">Client</h2>
        <p className="text-sm text-gray-500 mt-0.5">Contact for this booking</p>
      </div>

      <div className="space-y-3">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 mb-0.5">
            Name
          </p>
          <p className="text-sm font-semibold text-gray-900">{client.name}</p>
        </div>
        {client.phone ? (
          <div className="flex items-center gap-2 text-sm text-gray-800">
            <Phone className="w-4 h-4 text-gray-400 shrink-0" />
            <span className="break-all">{client.phone}</span>
          </div>
        ) : null}
        {client.email ? (
          <div className="flex items-center gap-2 text-sm text-gray-800">
            <Mail className="w-4 h-4 text-gray-400 shrink-0" />
            <span className="break-all">{client.email}</span>
          </div>
        ) : null}
      </div>

      <div className="mt-5 pt-5 border-t border-gray-100 space-y-2.5">
        {client.phone ? (
          <a
            href={`tel:${client.phone}`}
            className="flex items-center justify-center gap-2 w-full px-3 py-2.5 bg-gray-900 text-white rounded-xl hover:bg-black transition-colors text-sm font-medium"
          >
            <Phone className="w-4 h-4" />
            Call client
          </a>
        ) : null}
        <button
          type="button"
          onClick={onMessageClient}
          className="relative flex items-center justify-center gap-2 w-full px-3 py-2.5 border border-gray-300 text-gray-900 rounded-xl hover:bg-surface-muted transition-colors text-sm font-medium"
        >
          <MessageSquare className="w-4 h-4" />
          Message client
          {unread > 0 ? (
            <span className="absolute -top-1.5 -right-1.5 min-w-[1.25rem] h-5 px-1 flex items-center justify-center rounded-full bg-red-600 text-white text-[11px] font-semibold leading-none">
              {unread > 99 ? '99+' : unread}
            </span>
          ) : null}
        </button>
      </div>
    </section>
  );
};

export default ClientInformation;
